export default __webpack_public_path__ + "static/media/NotOpenSalesImage.db96ab81.png";